export default __webpack_public_path__ + "static/media/smiley.c6287e78.png";